// The <flix-cart> element itself stays intentionally thin: open/close are
// pure attribute toggles with zero network dependency (always instant),
// and every click is delegated through one listener bound on `document`
// exactly once — a plain module-scope flag, not a class-static or anything
// tied to a particular element instance, so it can't be duplicated or left
// stale if Shopify's Theme Editor ever recreates this element's markup.
(function () {
  var bound = false;
  var qtyTimers = {};

  function root() {
    return document.getElementById('flix-cart-drawer-root');
  }

  function open() {
    var el = root();
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    window.flixModalOpen();
  }

  function close() {
    var el = root();
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
    window.flixModalClose();
  }

  function setAgree(agreed) {
    var el = root();
    if (!el) return;
    var box = el.querySelector('[data-flix-cart-agree-box]');
    var checkout = el.querySelector('[data-flix-cart-checkout]');
    if (box) box.dataset.checked = agreed ? 'true' : 'false';
    if (checkout) checkout.dataset.enabled = agreed ? 'true' : 'false';
  }

  function toast(type, name) {
    document.dispatchEvent(new CustomEvent('flix:toast', { detail: { type: type, name: name } }));
  }

  function flyToCart(sourceBtn) {
    var dest = document.querySelector('[data-flix-cart-open]');
    if (!dest || !sourceBtn) return;
    try {
      var src = sourceBtn.getBoundingClientRect();
      var dst = dest.getBoundingClientRect();
      var fly = document.createElement('div');
      fly.style.cssText = 'position:fixed;z-index:400;left:0;top:0;width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#ff7a1a,#ffb259);box-shadow:0 0 20px rgba(255,122,26,.75);pointer-events:none;display:flex;align-items:center;justify-content:center;color:#160d05';
      fly.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      document.body.appendChild(fly);
      var x0 = src.left + src.width / 2 - 14, y0 = src.top + src.height / 2 - 14;
      var x1 = dst.left + dst.width / 2 - 14, y1 = dst.top + dst.height / 2 - 14;
      var anim = fly.animate([
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1 },
        { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 90) + 'px) scale(1.35)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.25)', opacity: .4 }
      ], { duration: 780, easing: 'cubic-bezier(.5,0,.6,1)' });
      anim.onfinish = function () {
        fly.remove();
        try {
          dest.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
        } catch (e) {}
      };
    } catch (err) {}
  }

  function qtyFor(btn) {
    if (btn.dataset.useQty !== 'true') return 1;
    var picker = btn.closest('flix-variant-picker');
    var qtyEl = picker && picker.querySelector('flix-qty-input');
    return qtyEl ? qtyEl.value : 1;
  }

  function handleAdd(btn, openAfter) {
    // Read once, now: the variant on the button at the moment of the click
    // is the one the customer asked for, whatever they select afterwards.
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var qty = qtyFor(btn);
    btn.disabled = true;
    btn.dataset.flixLoading = 'true';

    // Feedback the user is watching for fires immediately — it's cosmetic
    // only and can't desync real cart data, so there's no reason to make
    // it wait on a network round trip the way the cart numbers must.
    toast('add', btn.dataset.productTitle);
    flyToCart(btn);
    if (openAfter) open();

    window.FlixCartAPI.add(variantId, qty).then(function (cart) {
      window.FlixCartRender.renderCart(cart);
    }).catch(function (err) {
      toast('error', (err && err.data && err.data.description) || null);
    }).finally(function () {
      delete btn.dataset.flixLoading;
      // Back to what the current selection allows, not blindly enabled: the
      // customer may have switched to an unavailable variant meanwhile.
      btn.disabled = btn.dataset.unavailable === 'true';
    });
  }

  function refreshFromServer() {
    return window.FlixCartAPI.get().then(function (cart) {
      window.FlixCartRender.renderCart(cart);
      return cart;
    });
  }

  function changeLine(key, delta) {
    if (!key) return;
    var el = root();
    var row = el && el.querySelector('[data-flix-cart-line][data-key="' + key + '"]');
    var qtyEl = row && row.querySelector('[data-flix-cart-line-qty]');
    if (!qtyEl) return;
    var next = Math.max(1, (parseInt(qtyEl.textContent, 10) || 1) + delta);
    if (row) row.classList.add('flx-cart-line--busy');

    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      window.FlixCartAPI.change(key, next).then(function (cart) {
        window.FlixCartRender.renderCart(cart);
      }).catch(function () {
        toast('error', null);
        refreshFromServer();
      }).finally(function () {
        if (row) row.classList.remove('flx-cart-line--busy');
      });
    }, 350);
  }

  function removeLine(key) {
    if (!key) return;
    var el = root();
    var row = el && el.querySelector('[data-flix-cart-line][data-key="' + key + '"]');
    var title = row && row.querySelector('[data-flix-cart-line-title]');
    var titleText = title ? title.textContent : null;
    if (row) row.classList.add('flx-cart-line--busy');

    window.FlixCartAPI.change(key, 0).then(function (cart) {
      window.FlixCartRender.renderCart(cart);
      toast('remove', titleText);
    }).catch(function () {
      toast('error', null);
      if (row) row.classList.remove('flx-cart-line--busy');
      refreshFromServer();
    });
  }

  function onClick(e) {
    var addBtn = e.target.closest('[data-flix-add-to-cart]');
    if (addBtn && !addBtn.disabled) { handleAdd(addBtn, false); return; }

    var buyBtn = e.target.closest('[data-flix-buy-now]');
    if (buyBtn && !buyBtn.disabled) { handleAdd(buyBtn, true); return; }

    var openTrigger = e.target.closest('[data-flix-cart-open]');
    if (openTrigger) {
      open();
      // Attention moves into the drawer that just opened, so the trigger
      // holding on to focus afterward serves nothing — on iOS Safari a
      // tapped button can keep a visible focus ring past the tap itself,
      // which reads as "stuck" exactly where a shopper's finger just was.
      openTrigger.blur();
      return;
    }

    var cartEl = root();
    var withinCart = cartEl && (cartEl.contains(e.target) || e.target.closest('flix-cart'));
    if (!withinCart) return;

    if (e.target.closest('[data-flix-cart-close]') || e.target.closest('[data-flix-cart-backdrop]')) {
      close();
      return;
    }
    // The agreement checkbox's checked state is handled by the native
    // label->checkbox click + its own `change` event (see onChange) —
    // handling it again here would double-fire and desync the toggle.
    var incBtn = e.target.closest('[data-flix-cart-qty-inc]');
    if (incBtn) { changeLine(incBtn.dataset.key, 1); return; }
    var decBtn = e.target.closest('[data-flix-cart-qty-dec]');
    if (decBtn) { changeLine(decBtn.dataset.key, -1); return; }
    var removeBtn = e.target.closest('[data-flix-cart-remove]');
    if (removeBtn) { removeLine(removeBtn.dataset.key); return; }
  }

  // A modal dialog answers Escape. On window in capture, for the same
  // reason as every other overlay: a listener on document can stop the key.
  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    var el = root();
    if (!el || el.hidden) return;
    close();
  }

  function onChange(e) {
    if (e.target.matches && e.target.matches('[data-flix-cart-agree]')) {
      setAgree(e.target.checked);
    }
  }

  if (!bound) {
    bound = true;
    document.addEventListener('flix:cart:open', open);
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    window.addEventListener('keydown', onKeydown, true);
  }
})();
